import { Component, OnInit } from '@angular/core';
import { InfoService } from 'src/app/service/info.service';
import { LoginService } from 'src/app/service/login.service';

@Component({
  selector: 'app-puntos-venta',
  templateUrl: './puntos-venta.component.html',
  styleUrls: ['./puntos-venta.component.scss']
})
export class PuntosVentaComponent implements OnInit {
  msjError: any;
  session: any;

  constructor(private infoService: InfoService, private login: LoginService) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
  }

  filter = '';
  pVenta: any[];
  numParametro: number;
  error: boolean;
  loading: boolean;

  ngOnInit() {
    this.msjError = '';
    this.error = false;
    this.loading = false;
    this.numParametro = 13053;
    /*     this.pVenta = [
          {municipio: "sss", zona:"1", direccion:"av dhhcdhc", comercio: "sddc", pReferencia:"allá"},
          {municipio: "sss", zona:"2", direccion:"av dhhcdhc", comercio: "sddc", pReferencia:"allá"},
          {municipio: "sss", zona:"3", direccion:"av dhhcdhc", comercio: "sddc", pReferencia:"allá"},
          {municipio: "sss", zona:"4", direccion:"av dhhcdhc", comercio: "sddc", pReferencia:"allá"},
          {municipio: "sss", zona:"5", direccion:"av dhhcdhc", comercio: "sddc", pReferencia:"allá"},
          {municipio: "sss", zona:"6", direccion:"av dhhcdhc", comercio: "sddc", pReferencia:"allá"},
          {municipio: "sss", zona:"7", direccion:"av dhhcdhc", comercio: "sddc", pReferencia:"allá"},
          {municipio: "sss", zona:"8", direccion:"av dhhcdhc", comercio: "sddc", pReferencia:"allá"},
          {municipio: "sss", zona:"9", direccion:"av dhhcdhc", comercio: "sddc", pReferencia:"allá"},
        ] */

    this.getPuntosVenta();
  }

  getPuntosVenta() {
    let json = {
      idSesion: this.session.ksi,
      numParametro: this.numParametro
    }
    this.loading = true;
    this.infoService.getInfo(json).subscribe(res => {
      if (res) {
        if (res.numError === 1) {
          this.pVenta = res.info;
          this.loading = false;
        }
        else {
          this.loading = false;
          this.error = true;
          this.msjError = res.msjError;
        }
      }
    })
  }

}
